import React from 'react';

import { Button, Modal } from '@/components';
import { InfoIcon } from '@/components/Icons';

type ErrorMessageProps = {
    message: string | React.ReactNode;
    showButton: boolean;
    buttonText?: string | null;
    buttonClick?: () => void;
    onClose?: () => void;
    hideCloseButton?: boolean;
};

export const ErrorMessageModal = ({
    onClose,
    message,
    showButton,
    buttonText,
    buttonClick,
    hideCloseButton = false,
}: ErrorMessageProps) => {
    return (
        <Modal
            hideCloseButton={hideCloseButton}
            onClose={() => {
                onClose?.();
            }}
        >
            <div className="inline-flex flex-col items-start justify-start gap-6">
                <InfoIcon variant="default" />
                <div className="self-stretch">{message}</div>
                {showButton && (
                    <div className="ml-auto inline-flex items-center justify-end">
                        <Button variant="primary" onClick={buttonClick}>
                            {buttonText}
                        </Button>
                    </div>
                )}
            </div>
        </Modal>
    );
};
